import { render, staticRenderFns } from "./ActionRecordTable.vue?vue&type=template&id=2254abc4&scoped=true"
import script from "./ActionRecordTable.vue?vue&type=script&lang=js"
export * from "./ActionRecordTable.vue?vue&type=script&lang=js"
import style0 from "./ActionRecordTable.vue?vue&type=style&index=0&id=2254abc4&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254abc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2254abc4')) {
      api.createRecord('2254abc4', component.options)
    } else {
      api.reload('2254abc4', component.options)
    }
    module.hot.accept("./ActionRecordTable.vue?vue&type=template&id=2254abc4&scoped=true", function () {
      api.rerender('2254abc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/TeacherUseData/components/ActionRecordTable.vue"
export default component.exports